'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var utils = require('components/devices/views/controller/handling_view_utils');
var i18n = require('utils/i18n');
var Decorator = require('utils/decoration');

var OperatingModeView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/operating_modes_dialog'),

    ui: {
        save: '#js-save',
        holiday: '#js-holiday',
        modes: '.js-mode',

        time: '#js-validity-time',
        btnClearTime: '#js-clear-validity',
        btnEditTime: '#js-edit-validity',
    },

    events: {
        'click @ui.save': 'saveClicked',
        'click @ui.holiday': 'toggleHoliday',
        'click @ui.modes': 'switchMode',

        'click @ui.btnClearTime': 'clearTime',
        'click @ui.btnEditTime': 'editTime',
    },

    initialize: function (options) {
        this.settings = {};
        this.settings.auto_timer =
            this.model.attributes.auto_timer > 0
                ? moment().add(this.model.attributes.auto_timer, 'minutes')
                : undefined;
        this.settings.mode_chosen = this.model.attributes.mode_chosen;
        this.settings.is_holiday = this.model.attributes.is_holiday && this.model.attributes.is_holiday_possible;
        this.handleView = options.handleView;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.modeConfigs = utils.modeConfigs;
        data.showModeSettings = !this.settings.is_holiday || !this.model.attributes.is_holiday_possible;
        data.settings = this.settings;
        data.auto_timer_string =
            this.settings.auto_timer && (this.settings.is_holiday || this.settings.mode_chosen != 'auto')
                ? this.settings.auto_timer.format('DD.MM.YYYY HH:mm')
                : undefined;
        return data;
    },

    initializeDatePicker: function (timer) {
        var self = this;
        utils.initializeDatePicker(this.ui.time, timer, 'down', function (start, end, label) {
            if (!self.settings.is_holiday && self.settings.mode_chosen === 'auto') {
                return;
            }
            self.settings.auto_timer = start;
            self.render();
        });
    },

    clearTime: function () {
        this.settings.auto_timer = undefined;
        this.render();
    },

    editTime: function () {
        this.ui.time.data('daterangepicker').toggle();
    },

    onRender: function () {
        this.initializeDatePicker(this.settings.auto_timer);
    },

    onShow: function () {
        this.initializeDatePicker(this.settings.auto_timer);
    },

    switchMode: function (e) {
        this.settings.mode_chosen = $(e.currentTarget).attr('id').substring(3);
        this.render();
    },

    toggleHoliday: function () {
        this.settings.is_holiday = !this.settings.is_holiday;
        this.render();
    },

    saveClicked: function (event) {
        event.preventDefault();

        var validity_minutes = this.settings.auto_timer
            ? Math.max(this.settings.auto_timer.diff(moment(), 'minutes'), 0)
            : 0;
        validity_minutes = Math.min(validity_minutes, 65535);

        Decorator.disableElement('.modal-dialog');
        this.handleView.saveModel(
            {
                auto_timer: validity_minutes,
                mode_chosen: this.settings.is_holiday ? 'holiday' : this.settings.mode_chosen,
                changedValue: 'operatingMode',
            },
            i18n.TR('Änderungen wurden übernommen'),
            i18n.TR('Änderungen konnten nicht gespeichert werden.')
        );
    },
});

module.exports = OperatingModeView;
